import React, { useEffect } from "react";
import { Layout } from "common/dashboard/layout";
import { Stack, Grid, Typography, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getDetails, getmyCount } from "store/auth/authActions";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { updateRenewal } from "store/auth/authActions";
import { connect } from "react-redux";

function Dashboard({ updateRenewal }) {
  const navigate = useNavigate();

  let dispatch = useDispatch();
  useEffect(() => {
    dispatch(getmyCount());
    dispatch(
      getDetails({}, (e) => {
        if (
          e?.data?.status == "needMoreDetail" &&
          e?.data?.version == "2026-2027"
        ) {
          navigate("/needmoredetails");
        }

        if (
          e?.data?.status == "changeCategoryAndRenewPending" &&
          e?.data?.version == "2026-2027"
        ) {
          navigate("/changeCategory?step=1");
        }

        if (
          e?.data?.status == "renewPending" &&
          e?.data?.version == "2026-2027"
        ) {
          navigate("/renew?step=1");
        }
        if (
          e?.data?.status == "reApplyPending" &&
          e?.data?.version == "2026-2027"
        ) {
          navigate("/reApply?step=1");
        }

        if (e?.data?.status == "rejected" && e?.data?.version == "2026-2027") {
          navigate("/rejected");
          localStorage.removeItem("user-auth-x-token");
          localStorage.removeItem("user");
        }
      }),
    );
    window.scrollTo(0, 0);
  }, []);
  let counts = useSelector((s) => s.auth?.counts || undefined);
  let user = useSelector((s) => s.auth?.userData || undefined);

  const Boxdesign = ({ img, value, title, backgroundColor }) => (
    <Stack
      direction="row"
      sx={{
        backgroundColor,
        borderRadius: "14px",
        p: { lg: 4, xs: 2 },
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Stack sx={{ width: "15%" }}>
        <Stack
          style={{
            backgroundColor: "white",
            width: 88,
            height: 88,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            borderRadius: 88,
          }}
        >
          <img
            src={img}
            style={{ width: 40, height: 40, objectFit: "contain" }}
          />
        </Stack>
      </Stack>
      <Stack
        justifyContent={"center"}
        alignItems={"center"}
        ml={2}
        sx={{ width: "70%" }}
      >
        <Typography fontSize={"16px"} color={"#7E92A2"}>
          {title}
        </Typography>
        <Typography fontWeight={"bold"} fontSize={"40px"}>
          {value}
        </Typography>
      </Stack>
    </Stack>
  );
  return (
    <div className="bg_wrapper">
      <Layout>
        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            p: 0,
            m: 0,
            minHeight: "100vh",
          }}
        >
          {user?.isOldUser && !user?.isRenewalComplete && false && (
            <Grid sx={{ pl: { lg: 6, md: 4 }, pr: { lg: 6, md: 4 }, mt: 5 }}>
              {user?.status != "rejected" ? (
                <Typography variant="subtitle3">
                  Your 1-year contract is about to end! To continue
                  collaborating with us, You either apply for renewal under the
                  same category or with a category change.
                </Typography>
              ) : (
                <Typography variant="subtitle3">
                  Your application was rejected last year, you are now eligible
                  to reapply and join us again!
                </Typography>
              )}
            </Grid>
          )}

          {user?.isOldUser && !user?.isRenewalComplete && false && (
            <>
              {user?.status != "rejected" ? (
                <Grid
                  container
                  justifyContent={"center"}
                  alignItems={"center"}
                  spacing={4}
                  sx={{
                    py: { xs: "10px ", sx: "10px", md: "10px" },
                    px: { xs: "10px", sx: "10px", md: "30px" },
                  }}
                >
                  <Grid lg={3} xs={11} alignSelf={"center"} item>
                    <LoadingButton
                      //loading={loading}
                      fullWidth
                      size="large"
                      onClick={() => {
                        updateRenewal(
                          {
                            changeStatus: "renewPending",
                          },
                          0,
                          (e) => {},
                        );

                        navigate("/renew?step=1");
                      }}
                      variant="contained"
                    >
                      Renew Contract{" "}
                    </LoadingButton>
                  </Grid>
                  <Grid lg={3} xs={11} alignSelf={"center"} item>
                    <LoadingButton
                      //loading={loading}
                      fullWidth
                      size="large"
                      onClick={() => {
                        updateRenewal(
                          {
                            changeStatus: "changeCategoryAndRenewPending",
                          },
                          0,
                          (e) => {},
                        );

                        navigate("/changeCategory?step=1");
                      }}
                      variant="contained"
                    >
                      Renew & Change Category
                    </LoadingButton>
                  </Grid>
                </Grid>
              ) : (
                <Grid
                  container
                  justifyContent={"center"}
                  alignItems={"center"}
                  spacing={4}
                  sx={{
                    py: { xs: "10px ", sx: "10px", md: "10px" },
                    px: { xs: "10px", sx: "10px", md: "30px" },
                  }}
                >
                  <Grid lg={3} xs={11} alignSelf={"center"} item>
                    <LoadingButton
                      //loading={loading}
                      fullWidth
                      size="large"
                      onClick={() => {
                        updateRenewal(
                          {
                            changeStatus: "reApplyPending",
                          },
                          0,
                          (e) => {},
                        );

                        navigate("/reApply?step=1");
                      }}
                      variant="contained"
                    >
                      Re-apply
                    </LoadingButton>
                  </Grid>
                </Grid>
              )}
            </>
          )}
          {user?.isOldUser &&
            user?.isRenewalProcessComplete &&
            (user?.status == "renew" ||
              user?.status == "changeCategoryAndRenewPending" ||
              user?.status == "reApplyPending" ||
              user?.status == "reApply" ||
              user?.status == "renewPending" ||
              user?.status == "changeCategoryAndRenew") && (
              <Grid
                container
                justifyContent={"center"}
                className="white-box"
                alignItems={"center"}
                sx={{
                  py: { xs: "30px ", sx: "20px", md: "30px" },
                  px: { xs: "10px", sx: "10px", md: "10px" },
                  mt: 6,
                }}
              >
                <Grid lg={11} alignSelf={"center"} mt={2}>
                  {user?.status == "reApply" ? (
                    <Typography variant="subtitle2" mb={2} textAlign={"center"}>
                      Your application is under scrutiny.
                    </Typography>
                  ) : (
                    <Typography variant="subtitle2" mb={2} textAlign={"center"}>
                      Your Renewal request is under scrutiny.
                    </Typography>
                  )}
                </Grid>
              </Grid>
            )}
          {user?.status == "approved" && (
            <>
              {counts?.allAssignedTaskCount == 0 ? (
                <Grid
                  container
                  justifyContent={"center"}
                  className="white-box"
                  alignItems={"center"}
                  sx={{
                    py: { xs: "30px ", sx: "20px", md: "30px" },
                    px: { xs: "10px", sx: "10px", md: "10px" },
                    mt: 6,
                  }}
                >
                  <Grid lg={11} alignSelf={"center"}>
                    <Typography variant="h4">Congratulation, </Typography>
                  </Grid>
                  <Grid lg={11} alignSelf={"center"} mt={2}>
                    <Typography variant="subtitle2" textAlign={"center"}>
                      Your account has been approved.
                    </Typography>
                    <Typography variant="subtitle2" textAlign={"center"}>
                      Further steps will be informed over registered email and
                      sms.
                    </Typography>
                    <Typography variant="subtitle2" textAlign={"center"}>
                      You can also login to check your status here.{" "}
                    </Typography>
                  </Grid>
                  <Grid lg={5} alignSelf={"center"} mt={4}>
                    <img src="img/congrat.svg" style={{ marginTop: 5 }} />
                  </Grid>
                </Grid>
              ) : (
                <Grid
                  container
                  justifyContent={"center"}
                  alignItems={"center"}
                  spacing={4}
                  sx={{
                    py: { xs: "30px ", sx: "20px", md: "30px" },
                    px: { xs: "10px", sx: "10px", md: "30px" },
                  }}
                >
                  <Grid lg={4} xs={11} alignSelf={"center"} item>
                    <Boxdesign
                      img={"/img/taskplus.png"}
                      title={"Assigned Task"}
                      backgroundColor={"#FFF1D3"}
                      value={counts?.allAssignedTaskCount}
                    />
                  </Grid>
                  <Grid lg={4} xs={11} alignSelf={"center"} item>
                    <Boxdesign
                      img={"img/taskp.png"}
                      backgroundColor={"#FFC4C4"}
                      title={"Pending Task"}
                      value={counts?.inProgressAssignedTaskCount}
                    />
                  </Grid>

                  <Grid lg={4} xs={11} alignSelf={"center"} item>
                    <Boxdesign
                      img={"img/taskt.png"}
                      title={"Total Task"}
                      backgroundColor={"#E6EDF4"}
                      value={counts?.allAssignedTaskCount}
                    />
                  </Grid>
                  <Grid lg={4} xs={11} alignSelf={"center"} item>
                    <Boxdesign
                      img={"/img/taskdone.png"}
                      title={"Completed Task"}
                      value={counts?.completedAssignedTaskCount}
                      backgroundColor={"#C0E4DE"}
                    />
                  </Grid>
                  <Grid lg={4} xs={11} alignSelf={"center"} item>
                    <Boxdesign
                      img={"img/taskstar.png"}
                      title={"My Own Content"}
                      value={counts?.content?.allContentCount}
                      backgroundColor={"#D2D2D4"}
                    />
                  </Grid>

                  <Grid lg={4} xs={11} alignSelf={"center"} item>
                    <Boxdesign
                      img={"img/taskincom.png"}
                      title={"Laps Task"}
                      value={counts?.lapseAssignedTaskCount}
                      backgroundColor={"#EFD9CF"}
                    />
                  </Grid>
                </Grid>
              )}
            </>
          )}
        </Box>
      </Layout>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  updateRenewal: (data, step, callback) =>
    dispatch(updateRenewal(data, step, callback)),
});
export default connect(null, mapDispatchToProps)(Dashboard);
